module.exports = __webpack_public_path__ + "img/singlecross.b0b961e4.svg";